export default __webpack_public_path__ + "static/media/MarketWatch.f8da0672.svg";